import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";

/**
 * Created by jonas on 2022-08-24.
 */

export class GfxUtils {

    public static createTimelineSprite(assetName:string, position?:PIXI.Point):TimelineSprite {
        position = position ? position : new PIXI.Point(0, 0);
        let mc = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(assetName));
        mc.anchor.set(0.5, 0.5);
        mc.position.set(position.x, position.y);
        mc.name = assetName;
        mc.hide();
        mc.scale.set(0.6, 0.6);
        return mc;
    }

    public static createAttentionTimelineSprite(assetName:string, position?:PIXI.Point):TimelineSprite {
        position = position ? position : new PIXI.Point(0, 0);
        let mc = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures( assetName));
        mc.anchor.set(0.5, 0.5);
        mc.position.set(position.x, position.y);
        mc.name = assetName;
        mc.hide();
        return mc;
    }

    public static createSpite(assetName:string, position?:PIXI.Point, anchor?:PIXI.Point):PIXI.Sprite {
        position = position ? position : new PIXI.Point(0, 0);
        anchor = anchor ? anchor : new PIXI.Point(0, 0);
        let tempTexture:PIXI.Texture = KitchenDramaSushiMania.assetLoader.getTextures(assetName)[0];
        let sprite = new PIXI.Sprite(tempTexture);
        sprite.position.set(position.x, position.y);
        sprite.anchor.set(anchor.x, anchor.y);
        return sprite;

    }

}